import { userQueryOptions } from '@repo/cf-user/hooks/use-user-data'

import { useUserProfileInfoQuery } from '@web/gen/user'

export function useUserProfileFirstNameQuery() {
  return useUserProfileInfoQuery(undefined, {
    ...userQueryOptions,
    select(data) {
      return data.me?.user?.firstName
    },
  })
}

export function useUserProfileContentInterestQuery() {
  return useUserProfileInfoQuery(undefined, {
    ...userQueryOptions,
    select(data) {
      return data.me?.user?.contentInterests
    },
  })
}
